exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shipping-block-edit-form .shipping-block {\n  margin: 0 -8px;\n}\n.shipping-block-edit-form .shipping-block.has-error .address-autocomplete-input__root > .address-autocomplete-container:not(:has(.input-field)) .address-autocomplete__input-field input {\n    border: 1px solid red;\n}\n.shipping-block-edit-form .shipping-block.has-error .address-autocomplete-input__root .error-block {\n    display: block;\n}\n", ""]);

// exports
